var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import CoreLabeledTextbox, { Textbox as CoreTextbox } from 'nucleus-core/forms/elements/Textbox';
import wrapInput, { inputOptions } from '../wrapInput';
var textboxOptions = __assign(__assign({}, inputOptions), { inputIdKey: 'fieldName' });
export var Textbox = wrapInput(textboxOptions)(CoreTextbox);
var labeledTextboxOptions = __assign(__assign({}, textboxOptions), { defaultIncludeErrorMessages: true });
export default wrapInput(labeledTextboxOptions)(CoreLabeledTextbox);
